import { Box, Stack, Typography } from "@mui/material";
import TitleAndContent from "./TitleAndContent";

const listContents = [
    {
        "title": "Smooth out your Mac",
        "content": "Swipe out wasted memory through\none click",
        "imagePath": "/feature1.png"
    },
    {
        "title": "Keep in mind your choice",
        "content": "Cleaning wasted memory\nwithout thinking back",
        "imagePath": "/feature2.png"
    },
    {
        "title": "Rapid access status bar",
        "content": "Keep update-to-date your Mac’s health",
        "imagePath": "/feature3.png"
    },
]

export default function FeaturesSection() {
    return (<Stack sx={{
        width: '100%',
        alignItems: 'center',
        justifyContent: 'space-evenly',
    }}>
        <TitleAndContent title={"Feel the best experience with our features"} content={"Cleaning wasted memory without thinking back"} />
        <Stack
            direction={{ xs: 'column', sm: 'row' }}
            sx={{
                width: '100%',
                justifyContent: { xs: 'flex-start', sm: "space-evenly" },
                alignItems: 'center',
                marginTop: { xs: '2rem', sm: "10rem" },
            }}>
            {mapContents(listContents)}
        </Stack>
    </Stack>)
}

const mapContents = (contents) => contents.map(
    content => <Stack
        key={content.title}
        sx={{
            alignItems: 'center',
            justifyContent: 'center',
        }}>
        <Box
            component="img"
            sx={{ height: { xs: "12rem", sm: "21rem" }, width: { xs: "12rem", sm: "21rem" } }}
            alt={content.title}
            src={content.imagePath}
        />
        <Typography align="center" sx={{
            marginTop: "6rem",
            fontWeight: "bold",
            fontSize: "4rem",
            lineHeight: "4rem",
            marginBottom: "1rem",
            whiteSpace: "pre-wrap"
        }}>
            {content.title}
        </Typography>
        <Typography align="center" sx={{
            fontSize: "3rem",
            lineHeight: "4.5rem",
            whiteSpace: "pre-wrap",
            marginBottom: "10rem",
            color: '#A19FA8'
        }}>
            {content.content}
        </Typography>
    </Stack>
)